import styled from "styled-components";


export default function Line (){

    return (
        <Wrapper/>
    )
}

const Wrapper = styled.div`
    height: 10px;
    background: white;
    position: relative;
    z-index: 1;
    
    `